define('views/modals/ProductModalView',[
    "evertrue",
    "jquery",
    "underscore",
    "backbone",
    "views/components/FormView",
    "models/roles/RoleModel",
    "collections/ProductCollection",
    "models/organization/OrganizationModel"
], function ProductModalViewFactory ( EverTrue, $, _, Backbone, FormView, RoleModel, ProductCollection, OrganizationModel) {

    var productFormObj = {
        modal : 'modalOrgProducts',
        fieldset : [{
            legend: "Add a Product for this Organization",
            formElements : [{
                type: 'checkbox',
                key : 'products.community.name',
                label: 'Products',
                checkboxes : [
                    {key: 'products.community.name', val: "community", val_display: 'Community', checked: true},
                    {key: "products.givingtree.name", val: "givingtree", val_display: 'EverTrue'},
                    {key: "products.volunteers.name", val: "volunteers", val_display: 'Volunteers'}
                    ]
                },{
                type: 'radio',
                key : 'products.community.premium',
                label: 'Community Level',
                parsley: 'data-required=true',
                buttons: [
                    {val: "false", title: 'Standard'},
                    {val: "true", title: 'Premium'}
                    ]
                },{
                type: 'select',
                key: 'products.community.status',
                label: 'Community Status',
                parsley: 'data-required=true',
                select : [
                    {val: 'BUILD', val_display: 'Build'},
                    {val: 'PREVIEW', val_display: 'Preview'},
                    {val: 'TRIAL', val_display: 'Trial'},
                    {val: 'LIVE', val_display: 'Live'},
                    {val: 'DISCONTINUED', val_display: 'Discontinued'}
                    ]
                },{
                type: 'select',
                key: 'products.givingtree.status',
                label: 'EverTrue Status',
                parsley: 'data-required=true',
                select : [
                    {val: 'BUILD', val_display: 'Build'},
                    {val: 'PREVIEW', val_display: 'Preview'},
                    {val: 'TRIAL', val_display: 'Trial'},
                    {val: 'LIVE', val_display: 'Live'},
                    {val: 'DISCONTINUED', val_display: 'Discontinued'}
                    ]
                },{
                type: 'select',
                key: 'products.volunteers.status',
                label: 'Volunteers Status',
                parsley: 'data-required=true',
                select : [
                    {val: 'BUILD', val_display: 'Build'},
                    {val: 'PREVIEW', val_display: 'Preview'},
                    {val: 'TRIAL', val_display: 'Trial'},
                    {val: 'LIVE', val_display: 'Live'},
                    {val: 'DISCONTINUED', val_display: 'Discontinued'}
                    ]
                }]
            }]
        };

    var ProductModalView = FormView.extend({
        current_id: "",
        setId: function(id) {
            this.current_id = id;
        },

        onFormSubmit: function(changed){
            var view = this,
                formData = this.$("form").serializeNestedObject(),
                orgSchema = new OrganizationModel(),
                products = new ProductCollection();

            EverTrue.DNA.set(products.dna_key, products.parseProducts(formData.products));
            EverTrue.DNA.update(products.dna_key, {
                urlOverride: {params: {oid: view.current_id}},
                success: function(response){
                    EverTrue.alertView.alert("success", {message: "Organization Products Saved"});
                    $("#modalOrgProducts").modal("hide");
                },
                error: function(){
                    EverTrue.vent.trigger("closeOrgNav");
                    $("#modalOrgProducts").modal("hide");
                }
            });

            orgSchema.enableSchemaAndRoles({id: view.current_id}, formData.products);
        },
        formObj:  productFormObj
    });

    return ProductModalView;
});

